import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-center justify-space-between text-body-2" }
const _hoisted_2 = { class: "d-flex text-green align-center" }
const _hoisted_3 = { class: "ml-4" }
const _hoisted_4 = { class: "mr-4" }
const _hoisted_5 = { class: "d-flex text-red align-center" }
const _hoisted_6 = { class: "ml-4" }
const _hoisted_7 = { class: "mr-4" }
const _hoisted_8 = { class: "d-flex text-orange align-center" }
const _hoisted_9 = { class: "ml-4" }
const _hoisted_10 = { class: "mr-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: _normalizeClass({'el-fixed': !$props.visible })
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "6"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_v_icon, {
                        color: "success",
                        size: "x-large"
                      }, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode(" mdi-check-circle ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "font-weight-bold" }, "Approuvé", -1)),
                        _createElementVNode("p", null, _toDisplayString($props.approvedTotal.total) + " coupons", 1),
                        _createElementVNode("p", _hoisted_4, _toDisplayString($props.approvedTotal.amount) + " $ ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_v_icon, {
                        color: "error",
                        size: "x-large"
                      }, {
                        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                          _createTextVNode(" mdi-close-circle ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_6, [
                        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "font-weight-bold" }, "Rejeté", -1)),
                        _createElementVNode("p", null, _toDisplayString($props.rejectedTotal.total) + " coupons", 1),
                        _createElementVNode("p", _hoisted_7, _toDisplayString($props.rejectedTotal.amount) + " $ ", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_v_icon, {
                        color: "warning",
                        size: "x-large"
                      }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                          _createTextVNode(" mdi-alert-circle ", -1)
                        ]))]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_9, [
                        _cache[7] || (_cache[7] = _createElementVNode("p", { class: "font-weight-bold" }, "Non traité", -1)),
                        _createElementVNode("p", null, _toDisplayString($props.unprocessedTotal.total) + " coupons", 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString($props.unprocessedTotal.amount) + " $ ", 1)
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "3",
                class: "offset-md-3 d-flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    tile: "",
                    variant: "outlined",
                    color: "success text-normal",
                    disabled: $props.disableReport,
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('complete')))
                  }, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode(" Afficher rapport ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_btn, {
                    tile: "",
                    variant: "outlined",
                    color: "error text-normal",
                    class: "ml-5",
                    disabled: !$props.enableClear,
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clear')))
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Recommencer ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}